import { render, staticRenderFns } from "./AppListSelector.vue?vue&type=template&id=3c4fc66c&scoped=true&"
import script from "./AppListSelector.vue?vue&type=script&lang=ts&"
export * from "./AppListSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AppListSelector.vue?vue&type=style&index=0&id=3c4fc66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4fc66c",
  null
  
)

export default component.exports